var _rect, _path, _circle, _rect2, _path2, _circle2, _rect3, _path3, _circle3, _rect4, _path4, _rect5, _path5, _rect6, _circle4, _circle5, _circle6, _circle7, _path6, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 140,
    viewBox: "0 0 283 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 33,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F9B332"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.411 72.3633L48.6922 69.6218C48.2625 68.9429 47.4762 68.1909 47.7125 67.3788C48.2926 65.385 49.2981 63.4212 50.0716 61.4919C50.5684 62.7617 51.2536 63.9495 52.1041 65.0154C52.2955 65.291 52.5505 65.5165 52.8474 65.6729C53.1223 65.7737 53.4144 65.819 53.7068 65.8061L56.2593 65.8576C57.3378 65.8576 58.7043 65.9264 59.4477 64.9982C59.647 64.7434 59.7932 64.4512 59.8774 64.1388C59.9805 63.8494 60.0136 63.5396 59.974 63.2349C59.9344 62.9302 59.8233 62.6392 59.6496 62.3856C59.1899 61.8313 58.3605 61.7755 57.6472 61.7626L55.9757 61.7282C55.5262 61.7785 55.0718 61.764 54.6264 61.6852C54.4902 61.6244 54.3708 61.5315 54.2784 61.4145C53.5264 60.5551 53.3803 59.3219 52.856 58.3035C52.2336 57.2004 51.2828 56.3188 50.136 55.7811C48.3098 54.8487 45.9894 54.0408 43.9311 54.2557C42.3211 54.4899 40.7464 54.9229 39.2431 55.5448C38.8884 55.6589 38.5503 55.8192 38.2376 56.0218C36.9484 56.9327 36.059 58.6343 35.2597 59.9492C34.9031 60.5336 34.555 61.2383 34.787 61.8657C34.893 62.1365 35.066 62.3761 35.2898 62.5618C35.581 62.8436 35.946 63.0372 36.3426 63.1204C37.1203 63.2451 37.8766 62.7337 38.3665 62.1149C38.8563 61.4962 39.1786 60.7528 39.6556 60.134C40.0495 59.6351 40.5437 59.2244 41.1062 58.9283C41.6687 58.6323 42.2871 58.4575 42.9213 58.4152L40.6396 64.633C40.3986 65.3302 40.1115 66.0107 39.7802 66.6698C39.3956 67.3543 38.9649 68.0118 38.4911 68.6378C37.9883 69.3382 37.3395 70.8164 36.4457 71.057C36.0422 71.1298 35.6289 71.1298 35.2253 71.057L31.7877 70.6789C30.9283 70.5887 30.0088 70.5199 29.3298 71.0313C29.0258 71.2814 28.8042 71.6172 28.6938 71.9951C28.5835 72.3729 28.5895 72.7753 28.7111 73.1497C28.8416 73.5215 29.0542 73.859 29.3332 74.1372C29.6122 74.4155 29.9503 74.6272 30.3224 74.7568C31.0052 74.9586 31.7119 75.0685 32.4237 75.0834C34.2456 75.2509 36.0461 75.556 37.8852 75.6334C38.457 75.7204 39.0409 75.595 39.5267 75.281C40.154 74.7525 40.6912 73.661 41.1166 72.9649L43.1018 69.7293L44.5714 72.3075C44.8754 72.8847 45.2276 73.4352 45.6241 73.9532C45.9154 74.2698 46.1812 74.6089 46.4191 74.9673C46.6676 75.4935 46.8134 76.0623 46.8488 76.6432C47.0407 78.1185 47.2126 79.5924 47.3644 81.0648C47.3711 81.8027 47.5791 82.5248 47.966 83.1532C48.7438 84.1759 50.3766 84.1844 51.4466 83.4797C51.6714 83.348 51.858 83.1599 51.988 82.934C52.0891 82.6982 52.1361 82.4427 52.1255 82.1863C52.1204 81.5657 52.0788 80.9458 52.0009 80.33L51.4681 75.3927C51.4293 74.8951 51.34 74.4027 51.2017 73.9232C51.0042 73.3723 50.7386 72.8483 50.411 72.3633Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.4609,
    cy: 50.5371,
    r: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 33,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F9B332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.411 72.3633L144.692 69.6218C144.263 68.9429 143.476 68.1909 143.712 67.3788C144.293 65.385 145.298 63.4212 146.072 61.4919C146.568 62.7617 147.254 63.9495 148.104 65.0154C148.296 65.291 148.551 65.5165 148.847 65.6729C149.122 65.7737 149.414 65.819 149.707 65.8061L152.259 65.8576C153.338 65.8576 154.704 65.9264 155.448 64.9982C155.647 64.7434 155.793 64.4512 155.877 64.1388C155.98 63.8494 156.014 63.5396 155.974 63.2349C155.934 62.9302 155.823 62.6392 155.65 62.3856C155.19 61.8313 154.361 61.7755 153.647 61.7626L151.976 61.7282C151.526 61.7785 151.072 61.764 150.626 61.6852C150.49 61.6244 150.371 61.5315 150.278 61.4145C149.526 60.5551 149.38 59.3219 148.856 58.3035C148.234 57.2004 147.283 56.3188 146.136 55.7811C144.31 54.8487 141.989 54.0408 139.931 54.2557C138.321 54.4899 136.746 54.9229 135.243 55.5448C134.888 55.6589 134.55 55.8192 134.238 56.0218C132.948 56.9327 132.059 58.6343 131.26 59.9492C130.903 60.5336 130.555 61.2383 130.787 61.8657C130.893 62.1365 131.066 62.3761 131.29 62.5618C131.581 62.8436 131.946 63.0372 132.343 63.1204C133.12 63.2451 133.877 62.7337 134.366 62.1149C134.856 61.4962 135.179 60.7528 135.656 60.134C136.05 59.6351 136.544 59.2244 137.106 58.9283C137.669 58.6323 138.287 58.4575 138.921 58.4152L136.64 64.633C136.399 65.3302 136.111 66.0107 135.78 66.6698C135.396 67.3543 134.965 68.0118 134.491 68.6378C133.988 69.3382 133.339 70.8164 132.446 71.057C132.042 71.1298 131.629 71.1298 131.225 71.057L127.788 70.6789C126.928 70.5887 126.009 70.5199 125.33 71.0313C125.026 71.2814 124.804 71.6172 124.694 71.9951C124.583 72.3729 124.589 72.7753 124.711 73.1497C124.842 73.5215 125.054 73.859 125.333 74.1372C125.612 74.4155 125.95 74.6272 126.322 74.7568C127.005 74.9586 127.712 75.0685 128.424 75.0834C130.246 75.2509 132.046 75.556 133.885 75.6334C134.457 75.7204 135.041 75.595 135.527 75.281C136.154 74.7525 136.691 73.661 137.117 72.9649L139.102 69.7293L140.571 72.3075C140.875 72.8847 141.228 73.4352 141.624 73.9532C141.915 74.2698 142.181 74.6089 142.419 74.9673C142.668 75.4935 142.813 76.0623 142.849 76.6432C143.041 78.1185 143.213 79.5924 143.364 81.0648C143.371 81.8027 143.579 82.5248 143.966 83.1532C144.744 84.1759 146.377 84.1844 147.447 83.4797C147.671 83.348 147.858 83.1599 147.988 82.934C148.089 82.6982 148.136 82.4427 148.126 82.1863C148.12 81.5657 148.079 80.9458 148.001 80.33L147.468 75.3927C147.429 74.8951 147.34 74.4027 147.202 73.9232C147.004 73.3723 146.739 72.8483 146.411 72.3633Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.461,
    cy: 50.5371,
    r: 4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 25,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F9B332"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244.013 74.2037L241.865 70.7768C241.328 69.9281 240.345 68.9882 240.64 67.973C241.365 65.4807 242.622 63.026 243.589 60.6143C244.21 62.2017 245.066 63.6864 246.13 65.0188C246.369 65.3633 246.688 65.6451 247.059 65.8406C247.402 65.9666 247.767 66.0232 248.133 66.0071L251.324 66.0716C252.672 66.0716 254.38 66.1575 255.309 64.9973C255.558 64.6788 255.741 64.3135 255.846 63.9231C255.975 63.5612 256.017 63.174 255.967 62.7931C255.918 62.4122 255.779 62.0485 255.562 61.7316C254.987 61.0387 253.95 60.9688 253.059 60.9527L250.969 60.9098C250.407 60.9726 249.839 60.9546 249.283 60.856C249.112 60.78 248.963 60.6639 248.847 60.5177C247.907 59.4434 247.725 57.9018 247.07 56.6289C246.291 55.25 245.103 54.148 243.67 53.4759C241.387 52.3103 238.486 51.3005 235.913 51.5691C233.901 51.8618 231.933 52.4031 230.053 53.1805C229.61 53.3231 229.187 53.5236 228.796 53.7767C227.185 54.9154 226.073 57.0424 225.074 58.6861C224.628 59.4165 224.193 60.2974 224.483 61.0816C224.616 61.4202 224.832 61.7196 225.112 61.9518C225.476 62.304 225.932 62.5461 226.428 62.6501C227.4 62.8058 228.345 62.1666 228.958 61.3932C229.57 60.6197 229.973 59.6905 230.569 58.917C231.061 58.2934 231.679 57.78 232.382 57.4099C233.085 57.0398 233.858 56.8213 234.651 56.7685L231.799 64.5407C231.498 65.4123 231.139 66.2628 230.725 67.0867C230.244 67.9424 229.706 68.7643 229.113 69.5468C228.485 70.4223 227.674 72.27 226.557 72.5708C226.052 72.6618 225.536 72.6618 225.031 72.5708L220.734 72.0981C219.66 71.9853 218.51 71.8994 217.662 72.5386C217.282 72.8512 217.005 73.271 216.867 73.7434C216.729 74.2157 216.736 74.7186 216.888 75.1866C217.051 75.6513 217.317 76.0733 217.666 76.4211C218.015 76.7689 218.437 77.0336 218.903 77.1955C219.756 77.4478 220.639 77.5851 221.529 77.6037C223.807 77.8132 226.057 78.1945 228.356 78.2912C229.071 78.4 229.801 78.2433 230.408 77.8508C231.192 77.1901 231.863 75.8258 232.395 74.9557L234.877 70.9111L236.714 74.1339C237.094 74.8554 237.534 75.5435 238.03 76.1911C238.394 76.5868 238.726 77.0106 239.023 77.4587C239.334 78.1164 239.516 78.8274 239.561 79.5535C239.8 81.3976 240.015 83.24 240.205 85.0805C240.213 86.0029 240.473 86.9055 240.957 87.691C241.929 88.9693 243.97 88.9801 245.308 88.0992C245.589 87.9345 245.822 87.6994 245.985 87.417C246.111 87.1222 246.17 86.8029 246.156 86.4824C246.15 85.7066 246.098 84.9318 246.001 84.162L245.335 77.9904C245.286 77.3684 245.175 76.7529 245.002 76.1535C244.755 75.4648 244.423 74.8098 244.013 74.2037Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.076,
    cy: 46.9219,
    r: 5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 79,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.5 95L168.5 99L175.5 91",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 79,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 95L72.5 99L79.5 91",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 79,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 95,
    r: 2,
    fill: "#24284E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 95,
    r: 2,
    fill: "#24284E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 95,
    r: 2,
    fill: "#24284E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 138,
    r: 2,
    fill: "#6359D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215 116L207 130.5",
    stroke: "#6359D8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 21,
    r: 2,
    fill: "#6359D8"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 128.5,
    r: 1.5,
    fill: "#6359D8"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 5.5,
    r: 1.5,
    fill: "#6359D8"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 4.5,
    r: 1.5,
    fill: "#6359D8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.5,
    cy: 114.5,
    r: 1.5,
    fill: "#6359D8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 123.5,
    r: 1.5,
    fill: "#6359D8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 1.5,
    r: 1.5,
    fill: "#6359D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272 21.5L281 10.5",
    stroke: "#6359D8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 10L196 20.5",
    stroke: "#6359D8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceRunning);
export default __webpack_public_path__ + "static/media/persistence-running.4eca9a8eb764759653b83afd104b1c91.svg";
export { ForwardRef as ReactComponent };